"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.minimumAgeCondition = minimumAgeCondition;
exports.maximumAgeCondition = maximumAgeCondition;
exports.futureDateCondition = futureDateCondition;
exports.lastIncidentDateCondition = lastIncidentDateCondition;
const dateTime_1 = require("../../types/carrierQuestionnaire/conditions/dateTime");
const operators_1 = require("../../types/carrierQuestionnaire/conditions/operators");
const queryOperators_1 = require("../../types/carrierQuestionnaire/conditions/queryOperators");
/** Helper to create a condition based on the min age rather than the max date of birth */
function minimumAgeCondition(birthDateNodeId, value, unit, roundingType) {
    return {
        nodeId: birthDateNodeId,
        operator: operators_1.ComparisonOperators.lessThanOrEqual,
        controlValueQuery: {
            select: [dateTime_1.DateTimeReference.currentDateTime],
            operator: queryOperators_1.QueryOperators.shiftDateBackwards,
            operatorParams: {
                dateUnit: unit,
                shiftDateParams: {
                    shiftMagnitude: dateTime_1.ShiftMagnitudes.latestDateRespectingShiftValue,
                    dateFormat: 'YYYY-MM-DD',
                    shiftValue: value,
                    timeRoundingType: roundingType,
                },
            },
        },
    };
}
/** Helper to create a condition based on the max age rather than the min date of birth */
function maximumAgeCondition(birthDateNodeId, value, unit, roundingType) {
    return {
        nodeId: birthDateNodeId,
        operator: operators_1.ComparisonOperators.greaterThanOrEqual,
        controlValueQuery: {
            select: [dateTime_1.DateTimeReference.currentDateTime],
            operator: queryOperators_1.QueryOperators.shiftDateBackwards,
            operatorParams: {
                dateUnit: unit,
                shiftDateParams: {
                    shiftMagnitude: dateTime_1.ShiftMagnitudes.earliestDateRespectingShiftValue,
                    dateFormat: 'YYYY-MM-DD',
                    shiftValue: value,
                    timeRoundingType: roundingType,
                },
            },
        },
    };
}
function futureDateCondition(dateNodeId, value, unit, comparisonOperator) {
    return {
        query: {
            select: [dateTime_1.DateTimeReference.currentDateTime],
            operator: queryOperators_1.QueryOperators.shiftDateForwards,
            operatorParams: {
                dateUnit: unit,
                shiftDateParams: {
                    dateFormat: 'YYYY-MM-DD',
                    shiftValue: value,
                    timeRoundingType: dateTime_1.AgeRoundingTypes.none,
                },
            },
        },
        operator: comparisonOperator,
        controlValue: dateNodeId,
    };
}
function lastIncidentDateCondition(dateNodeId, value, unit, comparisonOperator, timeRoundingType = dateTime_1.AgeRoundingTypes.lastBirthday) {
    return {
        query: {
            select: [dateTime_1.DateTimeReference.currentDateTime],
            operator: queryOperators_1.QueryOperators.shiftDateBackwards,
            operatorParams: {
                dateUnit: unit,
                shiftDateParams: {
                    shiftMagnitude: dateTime_1.ShiftMagnitudes.latestDateRespectingShiftValue,
                    dateFormat: 'YYYY-MM-DD',
                    shiftValue: value,
                    timeRoundingType,
                },
            },
        },
        operator: comparisonOperator,
        controlValue: dateNodeId,
    };
}
